function orElse(x, defaultVal) {
  return isNullOrUndefined(x) ? defaultVal : x;
}
function isNull(x) {
  return x === null;
}
function isNotNull(x) {
  return x !== null;
}
function isUndefined(x) {
  return x === void 0;
}
function isDefined(x) {
  return x !== void 0;
}
function isNullOrUndefined(x) {
  return isNull(x) || isUndefined(x);
}
function isNotNullorUnDefined(x) {
  return isNotNull(x) && isDefined(x);
}
function isPresent(x) {
  return isNotNullorUnDefined(x);
}
function arrayIsNotEmpty(x) {
  return isNotNullorUnDefined(x) && x.length > 0;
}
function arrayIsEmpty(x) {
  return !arrayIsNotEmpty(x);
}
function isStringPresent(content) {
  if (content == null || content == void 0 || !isString(content)) return false;
  return content.trim() != "";
}
function isString(x) {
  return typeof x == "string";
}
const formatI18nCurrency = (value, currency, language, currentCurrency) => {
  const formatter = new Intl.NumberFormat(language, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  const formattedValue = formatter.format(value);
  const extendedUSDCurrencySymbol = currency == "USD" && isPresent(currentCurrency) && currentCurrency != "USD";
  const extendedFormattedValue = extendedUSDCurrencySymbol ? formattedValue.replace("$", "US$") : formattedValue;
  return extendedFormattedValue;
};
export { isStringPresent as a, isNull as b, isNotNull as c, isUndefined as d, isDefined as e, formatI18nCurrency as f, isNullOrUndefined as g, isNotNullorUnDefined as h, isPresent as i, arrayIsNotEmpty as j, arrayIsEmpty as k, isString as l, orElse as o };